import useDialogSearch from '@/composables/useDialogSearch'
import useProfileStore from '@/stores/profile.store'
import { toRef } from 'vue'

function usePresetSearch() {
  const profileStore = useProfileStore()
  const searchQuery = toRef(profileStore, 'presetSearchString')

  return useDialogSearch(searchQuery)
}

export default usePresetSearch
